// Display status constants — 5 computed values shown in the UI
export const VACCINATION_STATUS = {
  REGISTERED: 'Registered',
  FIRST_SHOT: 'First Shot',
  FIRST_EXPIRED: 'First Shot Expired',
  VACCINATED: 'Vaccinated',
  VACCINATION_EXPIRED: 'Vaccination Expired'
};

/**
 * Compute the display status from the raw DB status + vaccinationDate.
 * DB only stores 3 values: 'Registered', 'First Shot', 'Vaccinated'.
 * We derive the 5 UI statuses by checking how many days have passed since vaccinationDate.
 */
export const getVaccinationStatus = (pet) => {
  const now = new Date();
  if (pet.status === 'Vaccinated') {
    if (pet.vaccinationDate) {
      const vaxDate = pet.vaccinationDate.toDate ? pet.vaccinationDate.toDate() : new Date(pet.vaccinationDate);
      const days = Math.floor((now - vaxDate) / (1000 * 60 * 60 * 24));
      if (days >= 365) return VACCINATION_STATUS.VACCINATION_EXPIRED;
    }
    return VACCINATION_STATUS.VACCINATED;
  }
  if (pet.status === 'First Shot') {
    if (pet.vaccinationDate) {
      const vaxDate = pet.vaccinationDate.toDate ? pet.vaccinationDate.toDate() : new Date(pet.vaccinationDate);
      const days = Math.floor((now - vaxDate) / (1000 * 60 * 60 * 24));
      if (days >= 21) return VACCINATION_STATUS.FIRST_EXPIRED;
    }
    return VACCINATION_STATUS.FIRST_SHOT;
  }
  return VACCINATION_STATUS.REGISTERED;
};
